export default __webpack_public_path__ + "static/media/pic2.75aa0f90.jpg";